import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditEventTopicPayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editEventTopic = createSlice({
    name: 'eventTopic/edit-event-topic',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IEditEventTopicPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editEventTopicActions = editEventTopic.actions
export default editEventTopic.reducer
